const description = {
    email: 'email',
    phone_number: 'số điện thoại',
    username: 'tên người dùng',
    reminder: 'Nhắc nhở',
    not_found: '404 Không tìm thấy',
    agree_with_terms: 'Tôi đã đọc và đồng ý với ',
    agree_with_terms_modal: 'Để tiếp tục, vui lòng đồng ý với <link></link>.',
    terms_of_use: 'Điều khoản sử dụng',
    sign_in: 'Đăng nhập',
    privacy_policy: 'Chính sách bảo mật',
    create_account: 'Tạo tài khoản',
    or: 'hoặc',
    and: 'và',
    enter_passcode: 'Mã xác minh đã được gửi đến {{address}} {{target}} của bạn',
    passcode_sent: 'Mã xác minh đã được gửi lại',
    resend_after_seconds: 'Chưa nhận được? Gửi lại sau <span>{{seconds}}</span> giây',
    resend_passcode: 'Chưa nhận được? <a>Gửi lại mã xác minh</a>',
    create_account_id_exists: 'Tài khoản với {{type}} {{value}} đã tồn tại, bạn có muốn đăng nhập không?',
    link_account_id_exists: 'Tài khoản với {{type}} {{value}} đã tồn tại. Bạn có muốn liên kết không?',
    sign_in_id_does_not_exist: 'Tài khoản với {{type}} {{value}} không tồn tại, bạn có muốn tạo tài khoản mới không?',
    sign_in_id_does_not_exist_alert: 'Tài khoản với {{type}} {{value}} không tồn tại.',
    create_account_id_exists_alert: 'Tài khoản với {{type}} {{value}} đã được liên kết với một tài khoản khác. Vui lòng thử {{type}} khác.',
    social_identity_exist: '{{type}} {{value}} đã được liên kết với một tài khoản khác. Vui lòng thử {{type}} khác.',
    bind_account_title: 'Liên kết hoặc tạo tài khoản',
    social_create_account: 'Bạn có thể tạo tài khoản mới.',
    social_link_email: 'Bạn có thể liên kết email khác',
    social_link_phone: 'Bạn có thể liên kết số điện thoại khác',
    social_link_email_or_phone: 'Bạn có thể liên kết email hoặc số điện thoại khác',
    social_bind_with_existing: 'Chúng tôi đã tìm thấy một tài khoản liên quan đã được đăng ký, và bạn có thể liên kết trực tiếp.',
    skip_social_linking: 'Bỏ qua liên kết với tài khoản hiện có?',
    reset_password: 'Đặt lại mật khẩu',
    reset_password_description: 'Nhập {{types, list(type: disjunction;)}} liên kết với tài khoản của bạn, và chúng tôi sẽ gửi mã xác minh để đặt lại mật khẩu.',
    new_password: 'Mật khẩu mới',
    set_password: 'Đặt mật khẩu',
    password_changed: 'Đã thay đổi mật khẩu',
    no_account: 'Chưa có tài khoản? ',
    have_account: 'Đã có tài khoản?',
    enter_password: 'Nhập mật khẩu',
    enter_password_for: 'Đăng nhập bằng mật khẩu cho {{method}} {{value}}',
    enter_username: 'Đặt tên người dùng',
    enter_username_description: 'Tên người dùng là một cách khác để đăng nhập. Tên người dùng chỉ được chứa chữ cái, số và dấu gạch dưới.',
    link_email: 'Liên kết email',
    link_phone: 'Liên kết số điện thoại',
    link_email_or_phone: 'Liên kết email hoặc số điện thoại',
    link_email_description: 'Để tăng cường bảo mật, vui lòng liên kết email với tài khoản của bạn.',
    link_phone_description: 'Để tăng cường bảo mật, vui lòng liên kết số điện thoại với tài khoản của bạn.',
    link_email_or_phone_description: 'Để tăng cường bảo mật, vui lòng liên kết email hoặc số điện thoại với tài khoản của bạn.',
    continue_with_more_information: 'Để tăng cường bảo mật, vui lòng hoàn thành thông tin tài khoản dưới đây.',
    create_your_account: 'Tạo tài khoản của bạn',
    sign_in_to_your_account: 'Đăng nhập vào tài khoản của bạn',
    no_region_code_found: 'Không tìm thấy mã vùng',
    verify_email: 'Xác minh email của bạn',
    verify_phone: 'Xác minh số điện thoại của bạn',
    password_requirements: 'Mật khẩu {{items, list}}.',
    password_requirement: {
        length_one: 'yêu cầu tối thiểu {{count}} ký tự',
        length_other: 'yêu cầu tối thiểu {{count}} ký tự',
        character_types_one: 'phải chứa ít nhất {{count}} loại chữ hoa, chữ thường, số và ký tự đặc biệt',
        character_types_other: 'phải chứa ít nhất {{count}} loại chữ hoa, chữ thường, số và ký tự đặc biệt',
    },
    use: 'Sử dụng',
    single_sign_on_email_form: 'Nhập địa chỉ email doanh nghiệp của bạn',
    single_sign_on_connectors_list: 'Doanh nghiệp của bạn đã kích hoạt Đăng nhập một lần cho tài khoản email {{email}}. Bạn có thể tiếp tục đăng nhập với các nhà cung cấp SSO sau.',
    single_sign_on_enabled: 'Đăng nhập một lần đã được kích hoạt cho tài khoản này',
    authorize_title: 'Ủy quyền cho {{name}}',
    request_permission: '{{name}} đang yêu cầu quyền truy cập vào:',
    grant_organization_access: 'Cấp quyền truy cập cho tổ chức:',
    authorize_personal_data_usage: 'Ủy quyền sử dụng dữ liệu cá nhân của bạn:',
    authorize_organization_access: 'Ủy quyền truy cập vào tổ chức cụ thể:',
    user_scopes: 'Dữ liệu người dùng cá nhân',
    organization_scopes: 'Quyền truy cập tổ chức',
    authorize_agreement: 'Bằng cách ủy quyền truy cập, bạn đồng ý với <link></link> của {{name}}.',
    authorize_agreement_with_redirect: 'Bằng cách ủy quyền truy cập, bạn đồng ý với <link></link> của {{name}}, và sẽ được chuyển hướng đến {{uri}}.',
    not_you: 'Không phải bạn?',
    user_id: 'ID người dùng: {{id}}',
    redirect_to: 'Bạn sẽ được chuyển hướng đến {{name}}.',
    auto_agreement: 'Bằng cách tiếp tục, bạn đồng ý với <link></link>.',
    identifier_sign_in_description: 'Nhập {{types, list(type: disjunction;)}} của bạn để đăng nhập.',
    all_sign_in_options: 'Tất cả các tùy chọn đăng nhập',
    identifier_register_description: 'Nhập {{types, list(type: disjunction;)}} của bạn để tạo tài khoản mới.',
    all_account_creation_options: 'Tất cả các tùy chọn tạo tài khoản',
    back_to_sign_in: 'Quay lại đăng nhập',
    support_email: 'Email hỗ trợ: <link></link>',
    support_website: 'Trang web hỗ trợ: <link></link>',
};
export default Object.freeze(description);
